module.exports = __webpack_public_path__ + "a9c423821927eaa4f090d8ed6350aadd.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/wanzhuan/one/one-title.png
// module id = 1290
// module chunks = 0